// Shared with browser startup paths that must not evaluate protocol schemas.
export const GATEWAY_OWNER_PROFILE_ID = "gateway-owner";
